import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon }          from '@fortawesome/react-fontawesome'
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import { invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
import { XYPlot,
          Crosshair,
          DiscreteColorLegend,
          FlexibleWidthXYPlot,
          HorizontalGridLines,
          LineSeries,
          LineMarkSeries,
          VerticalGridLines,
          SearchableDiscreteColorLegend,
          XAxis,
          YAxis }        from 'react-vis';

const axisProps = {
    tickSizeInner: 0,
    style: {line: {stroke: '#939393', strokeWidth: '1px'}}
};

const vertebral_flexion_color   = "#c22a2a";
const vertebral_extension_color  = "#6621c4";
const transverse_rotation_left_cervical_color = "#2e78e7";
const transverse_rotation_right_cervical_color     = "#bf56fc";
const transverse_rotation_left_thoracic_color   = "#fc9856";
const transverse_rotation_right_thoracic_color      = "#fc56a0"
const lateral_flexion_left_color     = "#1bc9de";
const lateral_flexion_right_color    = "#3da211";

const SPINALROM_LEGEND = [
    {title: 'All',  data: "all_data", color: "#000", strokeWidth: 14},
    {title: 'Vertebral Flexion',  data: "vertebral_flexion_data", color: vertebral_flexion_color, strokeWidth: 14},
    {title: 'Vertebral Extension', data: "vertebral_extension_data", color: vertebral_extension_color, strokeWidth: 14 },
    {title: 'Transverse Rotation Left Cervical', data: "transverse_rotation_left_cervical_data", color: transverse_rotation_left_cervical_color, strokeWidth: 14 },
    {title: 'Transverse Rotation Right Cervical', data: "transverse_rotation_right_cervical_data", color: transverse_rotation_right_cervical_color, strokeWidth: 14 },
];

const SPINALROM_LEGEND2 = [
    {title: 'Transverse Rotation Left Thoracic', data: "transverse_rotation_left_thoracic_data", color: transverse_rotation_left_thoracic_color, strokeWidth: 14 },
    {title: 'Transverse Rotation Right Thoracic', data: "transverse_rotation_right_thoracic_data", color: transverse_rotation_right_thoracic_color, strokeWidth: 14 },
    {title: 'Lateral Flexion Left', data: "lateral_flexion_left_data", color: lateral_flexion_left_color, strokeWidth: 14 },
    {title: 'Lateral Flexion Right', data: "lateral_flexion_right_data", color: lateral_flexion_right_color, strokeWidth: 14 }
];

var vertebral_flexion_data                  = [];
var vertebral_extension_data                = [];
var transverse_rotation_left_cervical_data  = [];
var transverse_rotation_right_cervical_data = [];
var transverse_rotation_left_thoracic_data  = [];
var transverse_rotation_right_thoracic_data = [];
var lateral_flexion_left_data               = [];
var lateral_flexion_right_data              = [];

var legend1_title  = "Vertebral Flexion";
var legend2_title  = "Vertebral Extension";
var legend3_title  = "Transverse Rotation Left Cervical";
var legend4_title  = "Transverse Rotation Right Cervical";
var legend6_title  = "Transverse Rotation Left Thoracic";
var legend7_title  = "Transverse Rotation Right Thoracic";
var legend9_title  = "Lateral Flexion Left";
var legend11_title = "Lateral Flexion Right";

export default class AssessSpinalROM extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading:       false,
            title:           "Spinal ROM Assessment",
            all_data:        true,
            crosshairValues: [],
        }
    }

    componentDidMount() {

        try {
            this.getClientData();

        } catch (e) {
            alert(e);
        }
    }

    resetDataVals () {
        vertebral_flexion_data                  = [];
        vertebral_extension_data                = [];
        transverse_rotation_left_cervical_data  = [];
        transverse_rotation_right_cervical_data = [];
        transverse_rotation_left_thoracic_data  = [];
        transverse_rotation_right_thoracic_data = [];
        lateral_flexion_left_data               = [];
        lateral_flexion_right_data              = [];
    }

    getClientData = async () => {
        this.setState({
            loadingData: "Loading member data ... "
        })

        const results  = this.props.resultsSpinalROM; //await invokeGetClientAssessmentSpinalROMReport(client_id);

        var asessInbodyChartData = [];
        var max_yaxis_val        = [];

        // Reset all vals in case someone clicks "All" multiple times; we don't want multiple duplicate vals
        this.resetDataVals();

        if(results) {
            var data            = results.data.spinalrom;
            var ctr = 0;

            var max_array = [];
            ////  BEGIN: BUILD OUT GRAPH DATA  ////
            for(var key in data) {
                var vertebral_flexion                   = data[key].vertebral_flexion;
                var vertebral_extension                 = data[key].vertebral_extension;
                var transverse_rotation_left_cervical   = data[key].transverse_rotation_left_cervical;
                var transverse_rotation_right_cervical  = data[key].transverse_rotation_right_cervical;
                var transverse_rotation_left_thoracic   = data[key].transverse_rotation_left_thoracic
                var transverse_rotation_right_thoracic  = data[key].transverse_rotation_right_thoracic;
                var lateral_flexion_left                = data[key].lateral_flexion_left;
                var lateral_flexion_right               = data[key].lateral_flexion_right;
                var date_created                        = data[key].date_created;
                var date                = (new Date(date_created)).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })

                lateral_flexion_right_data.push({"x": date, "y": lateral_flexion_right});// test_arr[ctr++]});
                vertebral_flexion_data.push({"x": date, "y": vertebral_flexion});
                vertebral_extension_data.push({"x": date, "y": vertebral_extension});
                transverse_rotation_left_cervical_data.push({"x": date, "y": transverse_rotation_left_cervical});
                transverse_rotation_right_cervical_data.push({"x": date, "y": transverse_rotation_right_cervical});
                transverse_rotation_left_thoracic_data.push({"x": date, "y": transverse_rotation_left_thoracic});
                transverse_rotation_right_thoracic_data.push({"x": date, "y": transverse_rotation_right_thoracic});
                lateral_flexion_left_data.push({"x": date, "y": lateral_flexion_left});

                // Get Max Value of All Data points and then filter out the highest value to use in the y-axis //
                max_array.push(vertebral_flexion, vertebral_extension, transverse_rotation_left_cervical, transverse_rotation_right_cervical, transverse_rotation_left_thoracic, transverse_rotation_right_thoracic, lateral_flexion_left, lateral_flexion_right)
            }

            this.setState({
                report_data: data.length,
                all_data: true,
                lateral_flexion_right_data: lateral_flexion_right_data,
                vertebral_flexion_data: vertebral_flexion_data,
                vertebral_extension_data: vertebral_extension_data,
                transverse_rotation_left_cervical_data: transverse_rotation_left_cervical_data,
                transverse_rotation_right_cervical_data: transverse_rotation_right_cervical_data,
                transverse_rotation_left_thoracic_data: transverse_rotation_left_thoracic_data,
                transverse_rotation_right_thoracic_data: transverse_rotation_right_thoracic_data,
                lateral_flexion_left_data: lateral_flexion_left_data,
            })
        } else {
            //this.msgDataLoaded();
        }
    }

    onMouseLeave = () =>{
        this.setState({crosshairValues: []});
    }

    ////   Tooltip Hover   ////
    onNearestXTooltip = (value, {index}) => {
        var x   = vertebral_flexion_data[index].y;
        var x2  = vertebral_flexion_data[index].x;
        var y1  = vertebral_extension_data[index].y;
        var y2  = transverse_rotation_left_cervical_data[index].y;
        var y3  = transverse_rotation_right_cervical_data[index].y;
        var y5  = transverse_rotation_left_thoracic_data[index].y;
        var y6  = transverse_rotation_right_thoracic_data[index].y;
        var y8  = lateral_flexion_left_data[index].y;
        var y10 = lateral_flexion_right_data[index].y;

        this.setState({
                        crosshairValues: [{x: x2, y: y1}],
                        crossHairX:  x,
                        crossHairY1: y1,
                        crossHairY2: y2,
                        crossHairY3: y3,
                        crossHairY5: y5,
                        crossHairY6: y6,
                        crossHairY8: y8,
                        crossHairY10: y10,
                      });
    };

    handleLegendClick = item => {
        var data = item.data;
        var dataset;

        if(data === "all_data")
            this.setState({
                all_data: false
            }, () => {
                this.getClientData();
            });
        else {
            if(data === "vertebral_flexion_data")                       dataset = {"vertebral_flexion_data":vertebral_flexion_data};
            else if(data === "vertebral_extension_data")                dataset = {"vertebral_extension_data":vertebral_extension_data};
            else if(data === "transverse_rotation_left_cervical_data")  dataset = {"transverse_rotation_left_cervical_data":transverse_rotation_left_cervical_data};
            else if(data === "transverse_rotation_right_cervical_data") dataset = {"transverse_rotation_right_cervical_data": transverse_rotation_right_cervical_data};
            else if(data === "transverse_rotation_left_thoracic_data")  dataset = {"transverse_rotation_left_thoracic_data": transverse_rotation_left_thoracic_data};
            else if(data === "transverse_rotation_right_thoracic_data") dataset = {"transverse_rotation_right_thoracic_data": transverse_rotation_right_thoracic_data};
            else if(data === "lateral_flexion_left_data")               dataset = {"lateral_flexion_left_data": lateral_flexion_left_data};
            else if(data === "lateral_flexion_right_data")              dataset = {"lateral_flexion_right_data": lateral_flexion_right_data};

            // Clear out all data since we're fiultering out datasets
            this.setState({
                all_data: false,
                current_dataset: data,
                vertebral_flexion_data: [],
                vertebral_extension_data: [],
                transverse_rotation_left_cervical_data: [],
                transverse_rotation_right_cervical_data: [],
                transverse_rotation_left_thoracic_data: [],
                transverse_rotation_right_thoracic_data: [],
                lateral_flexion_left_data: [],
                lateral_flexion_right_data: []
            }, function (){
                this.setState(dataset);
            })
        }

        //const {items} = this.state;
        //item.disabled = !item.disabled;
    };

    getAllTooltip () {
        return <span>
                    <span style={{display:"inline-block", verticalAlign:"top", width: "50%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend1_title }: {this.state.crossHairX}%</span>
                        <span style={{display: "block",fontSize:16}}>{ legend2_title }: {this.state.crossHairY1}%</span>
                        <span style={{display: "block",fontSize:16}}>{ legend3_title }: {this.state.crossHairY2}%</span>
                        <span style={{display: "block",fontSize:16}}>{ legend4_title }: {this.state.crossHairY3}%</span>
                    </span>
                    <span style={{display:"inline-block", width: "50%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend6_title }: {this.state.crossHairY5}%</span>
                        <span style={{display: "block",fontSize:16}}>{ legend7_title }: {this.state.crossHairY6}%</span>
                        <span style={{display: "block",fontSize:16}}>{ legend9_title }: {this.state.crossHairY8}%</span>
                        <span style={{display: "block",fontSize:16}}>{ legend11_title }: {this.state.crossHairY10}%</span>
                    </span>
                </span>
    }

    // Show only 1 value in the tooltip hover //
    getSingleTooltip () {
        var dataset = this.state.current_dataset;
        var legend;
        var crosshair;
        if(dataset == "vertebral_flexion_data") {
            legend    = legend1_title;
            crosshair = this.state.crossHairX;
        } else if(dataset == "vertebral_extension_data") {
            legend    = legend2_title;
            crosshair = this.state.crossHairY1;
        } else if(dataset == "transverse_rotation_left_cervical_data") {
            legend    = legend3_title;
            crosshair = this.state.crossHairY2;
        } else if(dataset == "transverse_rotation_right_cervical_data") {
            legend    = legend4_title;
            crosshair = this.state.crossHairY3;
        } else if(dataset == "transverse_rotation_left_thoracic_data") {
            legend    = legend6_title;
            crosshair = this.state.crossHairY5;
        } else if(dataset == "transverse_rotation_right_thoracic_data") {
            legend    = legend7_title;
            crosshair = this.state.crossHairY6;
        } else if(dataset == "lateral_flexion_left_data") {
            legend    = legend9_title;
            crosshair = this.state.crossHairY8;
        } else if(dataset == "lateral_flexion_right_data") {
            legend    = legend11_title;
            crosshair = this.state.crossHairY10;
        }

        return <span>
                    <span style={{display:"inline-block", verticalAlign:"top", width: "100%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend }: { crosshair }%</span>
                    </span>
                </span>
    }

    render() {
        var title     = this.state.title;
        var all_data  = this.state.all_data;

        var report_data  = this.state.report_data;
        var no_data_text;
        if(report_data === 0)  no_data_text  = <div style={{position:"relative", top: 75, padding: 15, fontSize:18}}>There is no assessment data.</div>

        var tooltip;
        var tooltip_width = 220;
        if(all_data) {
            tooltip_width = 450;
            tooltip       = this.getAllTooltip();
        } else {
            tooltip       = this.getSingleTooltip();
        }

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                <div className="iconAddExercise35pxVertSpacer"></div>
                <span style={{position:"relative", left:-10}}>
                        <div style={{fontSize:22, textAlign:"center"}}>
                            <FontAwesomeIcon icon="hiking" style={{fontSize: '1.6em', paddingRight: 8 }}/>
                            <span style={{position:"relative", top:-4}}>
                                { title }
                                { no_data_text }
                            </span>
                        </div>
                        <span style={{display:"inline-block",width:"100%", border:"0px solid #000"}}>

                                <FlexibleWidthXYPlot height       = {200}
                                                     xType        = "ordinal"
                                                     yDomain      = {[0, 100]}
                                                     onMouseLeave = {this.onMouseLeave}
                                                     onMouseDown  = {() => {
                                                         //this.setState({showModalProgressDetail: true})
                                                        /*if (heldValue) {
                                                          this.setState({heldValue: false});
                                                          return;
                                                        }*/
                                                        //this.setState({heldValue: crosshairValues});
                                                      }}
                                                     >
                                  <VerticalGridLines />
                                  <HorizontalGridLines />

                                  <XAxis title="" {...axisProps}
                                         tickFormat={String}/>

                                     <YAxis title="Percentage" {...axisProps}
                                         //tickValues={[0,10,20,30,40,50,260]}
                                         tickFormat={String} />

                                  <LineMarkSeries data={this.state.vertebral_flexion_data}           size={2.5} color={vertebral_flexion_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.vertebral_extension_data}          size={2.5} color={vertebral_extension_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.transverse_rotation_left_cervical_data}        size={2.5} color={transverse_rotation_left_cervical_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.transverse_rotation_right_cervical_data}   size={2.5} color={transverse_rotation_right_cervical_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.transverse_rotation_left_thoracic_data}      size={2.5} color={transverse_rotation_left_thoracic_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.transverse_rotation_right_thoracic_data}              size={2.5} color={transverse_rotation_right_thoracic_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.lateral_flexion_left_data}             size={2.5} color={lateral_flexion_left_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.lateral_flexion_right_data}            size={2.5} color={lateral_flexion_right_color} onNearestX={this.onNearestXTooltip}/>

                                  <Crosshair values={this.state.crosshairValues} >
                                      <div style={{float: "left", background: 'black', borderRadius: 5, width: tooltip_width, maxWidth: tooltip_width, borderRadius:5, padding: 10, zIndex: 1000}}>
                                          <span style={{display:"inline-block", width:"100%", fontSize:18, textAlign:"center"}}>{ title }</span>
                                             <br/>
                                             { tooltip }
                                      </div>
                                  </Crosshair>

                                </FlexibleWidthXYPlot>
                                { /**********  LEGEND  ***********/ }
                                <div style={{float: "left",  zIndex: 10}}>
                                    <DiscreteColorLegend items={SPINALROM_LEGEND}
                                                         orientation='horizontal'
                                                         onItemClick={this.handleLegendClick}
                                                         style={{display: "inline-block", position:"relative", width:900, top:-7, left:35}}/>
                                    <DiscreteColorLegend items={SPINALROM_LEGEND2}
                                                          orientation='horizontal'
                                                          onItemClick={this.handleLegendClick}
                                                          style={{display: "inline-block", position:"relative", width:900, top:-20, left:35}}/>
                                </div>
                        </span>
                 </span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/report/AssessSpinalROM.js